import { ROTULO_DO_STATUS_NA_BASE, type StatusNaBase } from "@bookdental/schemas";
import { cn } from "@/lib/cn";

const COR: Record<StatusNaBase, string> = {
  PUBLICADO: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  RASCUNHO: "bg-amber-50 text-amber-700 ring-amber-200",
  ARQUIVADO: "bg-zinc-100 text-zinc-500 ring-zinc-200",
};

export function SeloDeStatus({ status }: { status: StatusNaBase }) {
  return (
    <span className={cn("inline-flex rounded-full px-2 py-0.5 text-[11px] font-semibold ring-1 ring-inset", COR[status])}>
      {ROTULO_DO_STATUS_NA_BASE[status]}
    </span>
  );
}
